import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const sensitivePeriods: BlogMetaData = {
  title: 'モンテッソーリ教育でよく聞く「敏感期」とは？子育てへの活かし方も解説！',
  description:
    'モンテッソーリ教育に触れていると、「敏感期」という言葉をよく耳にします。感受性が特に豊かになる大切な時期にどのように子どもと関わると良いでしょうか？詳しく解説します！',
  thumbnailUrl: '/img/blog-sensitive-periods-thumbnail.jpg',
  filePath: buildBlogFilePath('sensitive-periods'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
